"use strict";

var BoldText = require("app/shared/components/BoldText/bold-text");
var currency = require("app/util/formatter/currency.js");

var PlanCardHeader = React.createClass({
  mixins: [ReactIntl.IntlMixin],

  propTypes: {
    planName: React.PropTypes.string.isRequired,
    priceValue: React.PropTypes.number.isRequired,
    defaultValue: React.PropTypes.number,
  },

  getHeaderMessages: function() {
    var title = this.getIntlMessage("pricing.header.title");
    var formattedTitle = this.formatMessage(title, {planName: this.props.planName});
    var formattedPriceValue = currency.valueToViewFormat(this.props.priceValue);
    formattedPriceValue = currency.formatInteger(formattedPriceValue);

    var subtitle = this.getIntlMessage("pricing.header.subtitle");
    var formattedSubtitle= this.formatMessage(subtitle, {
      priceValue: formattedPriceValue
    });

    return {
      title: formattedTitle,
      subtitle: formattedSubtitle
    };
  },

  render: function() {
    var headerMessages = this.getHeaderMessages();
    var isDiscountApplied = this.props.defaultValue > this.props.priceValue;

    return (
      <div className="planCard-headText">
        <h2 className="fs-27 mt-0">
          <BoldText text={headerMessages.title} />
        </h2>
        <h4 className="pt-5">
          {
            isDiscountApplied
            ? <PriceDefaultValue defaultValue={this.props.defaultValue}/>
            : null
          }
          <BoldText text={headerMessages.subtitle} />
        </h4>
      </div>
    );
  }
});

const PriceDefaultValue = (props) => {
  var formattedDefaultValue = currency.valueToViewFormat(props.defaultValue);
  formattedDefaultValue = currency.formatInteger(formattedDefaultValue);

  var text = "**R$ " + formattedDefaultValue  + "**";

  return (
    <span className="c-light-grayish-blue td-lt">
      <BoldText text={text} />
    </span>
  );
};

module.exports = PlanCardHeader;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-header.jsx